import { PropertyFilterProcessingNode } from './PropertyFilterProcessingNode';
/**
 * @category Processing node
 */
export class EMAFilterNode extends PropertyFilterProcessingNode {
  constructor(propertySelector, propertyModifier, options) {
    super(propertySelector, propertyModifier, options);
  }
  initFilter(object, value, options) {
    return new Promise(resolve => {
      if (options.alpha > 1 || options.alpha < 0) {
        throw new Error(`Filter coefficient needs to be between 0 and 1!`);
      }
      resolve({
        x: value,
        alpha: options.alpha
      });
    });
  }
  filter(object, value, filter) {
    return new Promise(resolve => {
      if (typeof value === 'number') {
        filter.x = filter.x * (1 - filter.alpha) + filter.alpha * value;
      } else {
        const vector = value;
        const filterVector = filter.x;
        filter.x = filterVector.clone().multiplyScalar(1 - filter.alpha).add(vector.clone().multiplyScalar(filter.alpha));
      }
      resolve(filter.x);
    });
  }
}